import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getConversations } from '@api';

export const getCoreRecentAgentConversationsSlice = createGetAsyncSlice({
	name: 'coreRecentAgentConversations',
	receive: true,
	request: true,
	requestHandler: getConversations,
	retainDataOnRequest: true
});
